import { claimDailyGift } from '@betty/daily-gift';
import { loyaltyPointsUpdated } from '@betty/levels';
import { isAnyOf, socketConnected, startListening } from '@betty/toolkit/state';
import { getCoinBalance, depositApproved } from '@betty/wallet';
import { Notification, RewardType } from '@betty/rewards';
import { claimStatusReward, claimAllStatusRewards } from '@betty/status';
import { openShopRewardsBottomSheet } from '@betty/shop/state';
import { fetchDailyScratcher } from '@betty/daily-scratcher';

startListening({
  matcher: isAnyOf(
    depositApproved,
    claimDailyGift.fulfilled,
    claimStatusReward.fulfilled,
    claimAllStatusRewards.fulfilled,
    openShopRewardsBottomSheet,
  ),
  effect: (_, { dispatch }) => {
    dispatch(getCoinBalance());
  },
});

startListening({
  actionCreator: loyaltyPointsUpdated,
  effect: (action, { dispatch }) => {
    const hasCoinReward = action.payload.loyaltyRewards.some(
      (reward) => reward.rewardType === 'Coins',
    );

    if (hasCoinReward) {
      dispatch(getCoinBalance());
    }
  },
});

startListening({
  actionCreator: fetchDailyScratcher.fulfilled,
  effect: (action, { dispatch }) => {
    const rewardAmount = action.payload?.rewardAmount;
    if (rewardAmount && rewardAmount > 0) {
      dispatch(getCoinBalance());
    }
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      (notification: Notification) => {
        // Skip the fetch here becase we fetch when openShopRewardsBottomSheet is fired
        if (notification.sourceType === 'ItemPurchase') {
          return;
        }

        if (
          notification.rewards.some(
            (reward) => reward.rewardType === RewardType.Coins,
          )
        ) {
          dispatch(getCoinBalance());
        }
      },
    );
  },
});
